<template>
  <font-awesome-icon :icon="interchangeabilityIcon" :title="interchangeabilityTitle" />
</template>

<script>
  import { faSyncAlt, faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

  export default {
    name: "SupersessionIcon",
    components: {
      FontAwesomeIcon,
    },
    props: {
      type: {
        type: String,
        default: "SA",
      },
    },
    computed: {
      interchangeabilityIcon() {
        return this.type === "SA" ? faLongArrowAltDown : faSyncAlt;
      },
      interchangeabilityTitle() {
        return this.type === "SA" ? "Ahead" : "Interchangeable";
      },
    }
  };
</script>
